export default __webpack_public_path__ + "static/media/Delivery.c59db0ea.jpg";